import { useRef, useState } from "react";
import { motion } from "framer-motion";

export default function Start({ setUsername }) {
  const inputRef = useRef();
  const [inputValue, setInputValue] = useState("");

  const handleClick = () => {
    if (inputRef.current.value.trim()) {
      setUsername(inputRef.current.value.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      handleClick();
    }
  };

  return (
    <motion.div 
      className="start"
      initial={{ opacity: 0, scale: 0.8, y: 50 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ 
        duration: 0.8,
        type: "spring",
        stiffness: 100
      }}
    >
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
       Quiz Master
      </motion.h1>
      
      <motion.input
        className="startInput"
        placeholder="Enter your name to start"
        ref={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyPress={handleKeyPress}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        whileFocus={{ 
          scale: 1.02,
          transition: { duration: 0.2 }
        }}
      />
      
      <motion.button 
        className="startButton" 
        onClick={handleClick}
        disabled={!inputValue.trim()}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.5 }}
        whileHover={{ 
          scale: inputValue.trim() ? 1.05 : 1,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.95 }}
      >
        Start Quiz
      </motion.button>
      
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        style={{ 
          marginTop: "20px", 
          fontSize: "14px", 
          opacity: 0.8,
          textAlign: "center"
        }}
      >
        Answer 15 questions to win $1,000,000!
      </motion.p>
    </motion.div>
  );
}
